import { call, put, takeEvery, select, delay } from 'redux-saga/effects';

import { USER_DATA, SAGA_ERROR } from '../../../helpers/constants';
import { START_INTERNAL_CHATS } from '../../../helpers/internalChatConstants';
import { NOTIFY_UPDATE_LOGGED_USER_STATUS } from '../../../helpers/constants';
import { 
  CORPORATE_NOTIFY_USER_TYPING_MESSAGE, 
  CORPORATE_NOTIFY_MESSAGE, 
  CORPORATE_NOTIFY_MESSAGE_DELETE,
  CORPORATE_NOTIFY_FINISHED_CONVERSATION,
  REMOVE_CONTACT_FROM_LIST,
  CORPORATE_NOTIFY_MESSAGE_WAS_READ,
  CORPORATE_NOTIFY_GROUP_CREATED,
  CORPORATE_NOTIFY_GROUP_MESSAGE,
  CORPORATE_NOTIFY_GROUP_UPDATED,
  UPSERT_INTERNAL_CHAT_GROUP,
  RECEIVE_INTERNAL_CHAT_GROUP_MESSAGE,
  APPLY_INTERNAL_CHAT_GROUP_UPDATE
} from '../../../helpers/internalChatConstants';

import {
  updateUserIsTyping,
  addNewMessageToContact,
  updateExistinContact,
  craetaNewContact,
  updateActiveChatUserStatus,
  updateContactStatus,
  deleteMessageFromContact,
  removeContactFromList,
  changeMessageStatus
} from '../utils/internalChatFunctions/socketNotificationsFunc';

import {
  requestReadMessageIfActiveChat
} from '../utils/internalChatFunctions/requestReadMessagesFunc';

import { errorTypes, errorOrigin } from '../utils/toastActionCreator';

const getContacts = state => state.internalChat.contacts;
const getUserStatus = state => state.internalChat.userStatus;
const getActiveChat = state => state.internalChat.activeChat;
const getLoggedUserId = state => state.auth.userData?.id;


function* receiveIsTypingNotification(action) {
  const contacts = yield select(getContacts);
  yield put(updateUserIsTyping(contacts, action.payload));
}

function* receiveCorporateMessageNotification(action) {

  const contacts = yield select(getContacts);
  const userStatus = yield select(getUserStatus);
  const activeChat = yield select(getActiveChat);
  const updateContact = yield call(updateExistinContact, contacts, action.payload);
  if(activeChat && activeChat.user && activeChat.user.id === action.payload.conversationId) yield call(requestReadMessageIfActiveChat, action.payload);
  if (updateContact) {
    const updatedContactList = yield select(getContacts);
    yield put(addNewMessageToContact(updatedContactList, activeChat.user, action.payload));
  } else {
    yield put(craetaNewContact(contacts, userStatus, action.payload));
  }

}

function* changeUserStatusNotification(action) {

  const contacts = yield select(getContacts);
  const activeChat = yield select(getActiveChat);

  try {

    // if (activeChat?.user) yield put(updateActiveChatUserStatus(activeChat, action.payload));

    yield put(updateContactStatus(action.payload));

  } catch (e) {
    yield put({
      type: SAGA_ERROR,
      origin: errorOrigin.saga,
      errorType: errorTypes.error,
      response: e.message
    });
  }

}

function* deleteMessageByNotification(action) {
  const contacts = yield select(getContacts);

  try {
    yield put(deleteMessageFromContact(contacts, action.payload));
  } catch (e) {
    yield put({
      type: SAGA_ERROR,
      origin: errorOrigin.saga,
      errorType: errorTypes.error,
      response: e.message
    });
  }

}

function* removeConversationByNotification(action) {
  const contacts = yield select(getContacts);

  try {
    yield put(removeContactFromList(contacts, action.payload));
  } catch (e) {
    yield put({
      type: SAGA_ERROR,
      origin: errorOrigin.saga,
      errorType: errorTypes.error,
      response: e.message
    });
  }
}

function* changeMessageStatusByNotification(action) {
  const contacts = yield select(getContacts);

  try {
    yield put(changeMessageStatus(contacts, action.payload));
  } catch (e) {
    yield put({
      type: SAGA_ERROR,
      origin: errorOrigin.saga,
      errorType: errorTypes.error,
      response: e.message
    });
  }
}

/** GRUPOS
 *  A junção é feita no reducer, sobre o estado atual: o mesmo grupo pode chegar pela
 *  resposta da criação e pelo socket, ou pela listagem e pelo socket.
 */

/** Grupo criado: entra no topo; se já existir, é atualizado pelo id. */
function* receiveGroupCreatedNotification(action) {
  try {
    yield put({ type: UPSERT_INTERNAL_CHAT_GROUP, data: action.payload });
  } catch (e) {
    yield put({
      type: SAGA_ERROR,
      origin: errorOrigin.saga,
      errorType: errorTypes.error,
      response: e.message
    });
  }
}

/** Mensagem nova de outra pessoa: a própria chega pela resposta do envio. */
function* receiveGroupMessageNotification(action) {
  try {
    yield put({ type: RECEIVE_INTERNAL_CHAT_GROUP_MESSAGE, data: action.payload });
  } catch (e) {
    yield put({
      type: SAGA_ERROR,
      origin: errorOrigin.saga,
      errorType: errorTypes.error,
      response: e.message
    });
  }
}

/** Participantes, nome ou exclusão mudaram. Também é por aqui que chega o grupo para
 *  quem acabou de ser adicionado. O usuário logado é lido na hora do evento.
 */
function* receiveGroupUpdatedNotification(action) {
  try {
    const loggedUserId = yield select(getLoggedUserId);
    yield put({ type: APPLY_INTERNAL_CHAT_GROUP_UPDATE, data: { group: action.payload, loggedUserId } });
  } catch (e) {
    yield put({
      type: SAGA_ERROR,
      origin: errorOrigin.saga,
      errorType: errorTypes.error,
      response: e.message
    });
  }
}

export default function* socketNotificationsSaga() {
  yield takeEvery(CORPORATE_NOTIFY_USER_TYPING_MESSAGE, receiveIsTypingNotification);
  yield takeEvery(CORPORATE_NOTIFY_MESSAGE, receiveCorporateMessageNotification);
  yield takeEvery(NOTIFY_UPDATE_LOGGED_USER_STATUS, changeUserStatusNotification);
  yield takeEvery(CORPORATE_NOTIFY_MESSAGE_DELETE, deleteMessageByNotification);
  yield takeEvery(CORPORATE_NOTIFY_FINISHED_CONVERSATION, removeConversationByNotification);
  yield takeEvery(CORPORATE_NOTIFY_MESSAGE_WAS_READ, changeMessageStatusByNotification);
  yield takeEvery(CORPORATE_NOTIFY_GROUP_CREATED, receiveGroupCreatedNotification);
  yield takeEvery(CORPORATE_NOTIFY_GROUP_MESSAGE, receiveGroupMessageNotification);
  yield takeEvery(CORPORATE_NOTIFY_GROUP_UPDATED, receiveGroupUpdatedNotification);
}